import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";
/*const getMenu = () => {
  return axios.get(process.env.REACT_APP_API_URL + "/menu", { headers: authHeader() });
};*/

const getMenu = () => {
	console.log(localStorage.getItem("menu"));
	var localMenu = localStorage.getItem("menu");
	if (localMenu && localMenu !== undefined && localMenu !== "undefined") {
		return Promise.resolve(JSON.parse(localStorage.getItem("menu")));
	}
	return axios
		.get(process.env.REACT_APP_API_URL + "/menu", { headers: AuthHeader.authHeader() })
		.then((response) => {
			if (response.data) {
				localStorage.setItem("menu", JSON.stringify(response.data));
			}
			return response.data;
		});
};

const getCatalog = (categoryParams) => {
	let config = {
		headers: AuthHeader.authHeader(),
		params: {
			categoryId: categoryParams[0],
			range: JSON.stringify([categoryParams[1], categoryParams[2]]),
			searchTerm: categoryParams[3],
			priceFilter: categoryParams[4],
			brandFilter: categoryParams[5],
			priceRange: categoryParams[6],
			colorFilter: categoryParams[7]
		},
	}

	return axios.get(process.env.REACT_APP_API_URL + "/catalog", config)
		.then((response) => {
			for (var i = 0; i < response.data.data.length; i++) {
				response.data.data[i].colors = JSON.parse(response.data.data[i].colors);
			}
			return response.data;
		});
};

export const searchCatalog = async (search) => {
	try {
		console.log("SEARCH TERMS", search);
		let config = {
			headers: AuthHeader.authHeader(),
			params: {
				searchTerm: search[0],
				range: JSON.stringify([search[1], search[2]])
			},
		}

		const response = await axios.get(process.env.REACT_APP_API_URL + "/catalog/search/all", config);
		for (var i = 0; i < response.data.data.length; i++) {
			response.data.data[i].colors = JSON.parse(response.data.data[i].colors);
		}
		return response.data;
	} catch (error) {
		console.log(error);
	}
};
const getAdminCatalog = () => {
	return axios
		.get(process.env.REACT_APP_API_URL + "/admin/catalog/0", { headers: AuthHeader.authHeader() })
		.then((response) => {
			return response.data;
		});
};

const searchAdminCatalog = async (searchTerm, range) => {
	let config = {
		headers: AuthHeader.authHeader(),
		params: {
			searchTerm: searchTerm,
			range: JSON.stringify(range)
		},
	}

	const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/catalog/search/all", config);
	for (var i = 0; i < response.data.data.length; i++) {
		response.data.data[i].colors = JSON.parse(response.data.data[i].colors);
	}
	return response.data;
};


const loadNewSanmarProduct = async (styleId) => {
	let config = {
		headers: AuthHeader.authHeader(),
	}

	const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/sanmarLoadStyle/" + styleId, config);
	console.log("SANMAR ITEMS FOUND", response);

	return JSON.parse(response.data.data);
};


const addCatalogItem = async (items) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/addtocatalog",
		{
			"items": items.items,
			"decorationCode": items.decorationCode
		},
		{ headers: AuthHeader.authHeader() });
	if (response.status) console.log(response.status);
};

const addColorToCatalogItem = async (colorId, styleId) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/addcolor",
		{
			"colorId": colorId,
			"styleId": styleId
		},
		{ headers: AuthHeader.authHeader() });
	if (response.status) console.log(response.status);
};
const removeColorFromCatalogItem = async (colorId, styleId) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/removecolor",
		{
			"colorId": colorId,
			"styleId": styleId
		},
		{ headers: AuthHeader.authHeader() });
	if (response.status) console.log(response.status);
};

const getImagesForProduct = async (productId) => {
	let config = {
		headers: AuthHeader.authHeader(),
	}

	const response = await axios.get(process.env.REACT_APP_API_URL + "/images/" + productId, config);
	return response.data;
};

const getMainImageForProduct = async (productId) => {
	let config = {
		headers: AuthHeader.authHeader(),
	}

	const response = await axios.get(process.env.REACT_APP_API_URL + "/mainimage/" + productId, config);
	return response.data;
};

const removeFromCatalog = async (productId) => {
	let config = {
		headers: AuthHeader.authHeader(),
	}

	const response = await axios.delete(process.env.REACT_APP_API_URL + "/admin/removefromcatalog/" + productId, config);
	return response.data;
};

const updateDescription = async (productId, description) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/updatedescription",
		{
			"productId": productId,
			"description": description
		},
		{ headers: AuthHeader.authHeader() });
	if (response.status) console.log(response.status);
};

const toggleLight = async (colorId, value, prodictId) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/togglelight",
		{
			"colorId": colorId,
			"value": value,
			productId: prodictId
		},
		{ headers: AuthHeader.authHeader() });
	return response.data;
};

const getCatalogItem = async (itemId) => {
	const response = await axios.get(process.env.REACT_APP_API_URL + "/catalog/item/" + itemId, { headers: AuthHeader.authHeader() });

	for (var i = 0; i < response.data.items.length; i++) {
		response.data.items[i].sizes = JSON.parse(response.data.items[i].sizes);
		response.data.items[i].sizes.sort(function compareFn(a, b) {
			if (a.order < b.order) {
				return -1;
			}
			if (a.order > b.order) {
				return 1;
			}
			// a must be equal to b
			return 0;
		});
	}

	return response.data;
}
const updateAllSanmar = async () => {
	const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/updateAllSanmar", { headers: AuthHeader.authHeader() });
	return response.data;
}
const cloneProduct = async (productId, subsites) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/cloneProduct",
		{
			"productId": productId,
			"subsites": subsites
		},
		{ headers: AuthHeader.authHeader() });
	return response.data;
}

const addNewHireKitItem = async (productId, logos) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/newhirekititem",
		{
			"productId": productId,
			"subsiteDecorations": logos
		},
		{ headers: AuthHeader.authHeader() });
	if (response.status) console.log(response.status);
}

const removeNewHireKitItem = async (itemId) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/newhirekititem/remove",
		{ "id": itemId },
		{ headers: AuthHeader.authHeader() });
	if (response.status) console.log(response.status);
}

const getNewHireKitItems = async (productId) => {
	const response = await axios.get(process.env.REACT_APP_API_URL + "/admin/newhirekititems/", { headers: AuthHeader.authHeader() });
	return response.data;
}

const addProduct = async (product) => {
	const data = new FormData();

	data.append('description', product.description);
	data.append('categories', JSON.stringify(product.categories));
	data.append('title', product.title);
	data.append('modelCode', product.modelCode);
	data.append('price', product.price);
	data.append('colorName', product.colorName);
	data.append('hexColor', product.hexColor);
	data.append('size', product.size);
	data.append('maker', product.maker);
	data.append('uploadedImage', product.uploadedImage[0]);


	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/addproduct", data,
		{
			headers: {
				...AuthHeader.authHeader(),
				'Content-Type': 'multipart/form-data'
			}
		});
	return response.data;
}

const limitProductToRole = async (productId, role, value) => {
	const response = await axios.post(process.env.REACT_APP_API_URL + "/admin/limitproducttorole",
		{
			"productId": productId,
			"role": role,
			"value": value
		},
		{ headers: AuthHeader.authHeader() });
	return response.data;
}

const CatalogService = {
	getMenu,
	getCatalog,
	searchCatalog,
	getAdminCatalog,
	searchAdminCatalog,
	addCatalogItem,
	loadNewSanmarProduct,
	getImagesForProduct,
	removeFromCatalog,
	getMainImageForProduct,
	updateDescription,
	toggleLight,
	addColorToCatalogItem,
	removeColorFromCatalogItem,
	getCatalogItem,
	updateAllSanmar,
	cloneProduct,
	addNewHireKitItem,
	removeNewHireKitItem,
	getNewHireKitItems,
	addProduct,
	limitProductToRole
};
export default CatalogService;